/**
 * Chargement par lots de la grille collection.
 * La liste est servie en deux temps par Shopify (en stock, puis épuisés) ; ce
 * script les enchaîne de façon invisible : chaque lot affiche data-fs-batch
 * produits, la page initiale est complétée avec les épuisés si nécessaire, et
 * les produits récupérés en trop sont gardés en réserve pour le lot suivant.
 */
(function () {
  var state = null;

  function getSectionId() {
    var grid = document.getElementById('product-grid');
    if (grid && grid.dataset.id) return grid.dataset.id;
    var wrapper = document.getElementById('main-collection-filters');
    return wrapper ? wrapper.dataset.id : null;
  }

  function initSwatches(items) {
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var $items = $(items);

    $items.find('.product-swatch-color a').on('click', function (e) {
      e.preventDefault();
      var $card = $(this).parents('.item-product');
      $card.find('.product__thumbnail').attr('srcset', $(this).data('image-variant'));
      $card.find('.product__thumbnail-second').addClass('hidden');
      $card.find('.product__thumbnail').addClass('block');
      $(this).parent('.swatch-element').addClass('act').siblings().removeClass('act');
    });

    $items.find('.product-swatch-color').each(function () {
      var $swatch = $(this);
      var extra = $swatch.children('.swatch-element').length - 3;
      if (extra > 0) {
        $swatch.find('.number').text(extra);
        $swatch.find('.show_more').show();
      }
      $swatch.find('.swatch-element:gt(2)').addClass('hide');
      $swatch.children('.show_more').on('click', function () {
        var $btn = $(this);
        if ($btn.hasClass('active')) {
          $btn.parent().find('.hide').hide();
          $btn.removeClass('active');
          $btn.parent().find('.number').show();
        } else {
          $btn.parent().find('.hide').show();
          $btn.addClass('active');
          $btn.parent().find('.number').hide();
        }
      });
    });
  }

  function convertCurrency() {
    if (typeof window.Currency === 'undefined' || typeof window.jQuery === 'undefined') return;
    if (typeof window.shopCurrency === 'undefined') return;
    window.Currency.convertAll(window.shopCurrency, window.jQuery('#currencies span.selected').attr('data-currency'));
  }

  function fetchPage(url) {
    var sectionId = getSectionId();
    var target = new URL(url, window.location.origin);
    if (sectionId) target.searchParams.set('section_id', sectionId);
    return fetch(target.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.getElementById('product-grid');
        var items = grid ? Array.prototype.slice.call(grid.querySelectorAll(':scope > .product--item')) : [];
        var nextLink = doc.querySelector('[data-fs-load-more] [data-fs-load-more-link]');
        return { items: items, nextUrl: nextLink ? nextLink.getAttribute('href') : null };
      });
  }

  function render() {
    var s = state;
    if (!s) return;
    var shown = s.grid.querySelectorAll('.product--item').length;
    var hasMore = s.buffer.length > 0 || Boolean(s.nextUrl);
    var status = s.container.querySelector('[data-fs-load-more-status]');
    var bar = s.container.querySelector('[data-fs-load-more-bar]');

    if (s.link) {
      s.link.hidden = !hasMore;
      s.link.classList.toggle('is-loading', s.loading);
      s.link.setAttribute('aria-busy', s.loading ? 'true' : 'false');
      if (s.nextUrl) s.link.setAttribute('href', s.nextUrl);
    }

    if (!hasMore && !s.loading) {
      var toolbarCount = document.querySelector('#FsToolbarCount .fs-toolbar-count__n');
      var toolbarLabel = document.querySelector('#FsToolbarCount .fs-toolbar-count__l');
      if (toolbarCount) toolbarCount.textContent = shown;
      if (toolbarLabel) toolbarLabel.textContent = shown > 1 ? 'parfums' : 'parfum';
    }

    if (status) {
      if (!hasMore && shown === 1) {
        status.textContent = 'Vous avez vu le parfum';
      } else if (!hasMore && shown > 0) {
        status.textContent = 'Vous avez vu les ' + shown + ' parfums';
      } else if (s.total) {
        status.textContent = shown + ' parfums affichés sur ' + s.total;
      } else if (shown > 0) {
        status.textContent = shown + ' parfums affichés';
      } else {
        status.textContent = '';
      }
    }
    if (bar) {
      var width = !hasMore ? 100 : s.total ? Math.min(100, Math.round((shown / s.total) * 100)) : 0;
      bar.style.width = width + '%';
    }

    var showEmpty = !s.loading && shown === 0 && !hasMore;
    var empty = s.container.querySelector('[data-fs-load-more-empty]');
    if (empty) empty.hidden = !showEmpty;

    // Rien à afficher sous la grille tant que tout tient dans le premier lot.
    s.container.hidden = !(showEmpty || (!s.autoFilling && (hasMore || s.clicked)));
  }

  function append(items) {
    var s = state;
    var appended = items.map(function (item) {
      return s.grid.appendChild(document.importNode(item, true));
    });
    if (!appended.length) return appended;
    initSwatches(appended);
    convertCurrency();
    document.dispatchEvent(new CustomEvent('fs:products-appended', { detail: { items: appended } }));
    return appended;
  }

  /** Ajoute `count` produits à la grille, en puisant dans la réserve puis dans les pages suivantes. */
  function fill(count) {
    var s = state;
    if (!s || s.loading) return Promise.resolve([]);
    var token = s.token;
    var added = [];
    s.loading = true;
    render();

    function step() {
      if (state !== s || s.token !== token) return Promise.resolve();
      var missing = count - added.length;
      if (missing > 0 && s.buffer.length) {
        added = added.concat(append(s.buffer.splice(0, missing)));
        missing = count - added.length;
      }
      if (missing <= 0 || !s.nextUrl) return Promise.resolve();
      var url = s.nextUrl;
      return fetchPage(url).then(function (page) {
        if (state !== s) return;
        s.nextUrl = page.nextUrl && page.nextUrl !== url ? page.nextUrl : null;
        s.buffer = s.buffer.concat(page.items);
        return step();
      });
    }

    return step()
      .catch(function () {
        if (state === s && s.link) window.location.href = s.link.href;
      })
      .then(function () {
        if (state !== s) return added;
        s.loading = false;
        render();
        return added;
      });
  }

  function init() {
    var grid = document.getElementById('product-grid');
    var container = document.querySelector('[data-fs-load-more]');
    if (!grid || !container) {
      state = null;
      return;
    }
    if (state && state.container === container) return;

    var link = container.querySelector('[data-fs-load-more-link]');
    state = {
      token: Date.now() + Math.random(),
      grid: grid,
      container: container,
      link: link,
      nextUrl: link ? link.getAttribute('href') : null,
      buffer: [],
      batch: Number(container.dataset.fsBatch) || 60,
      total: Number(container.dataset.fsTotal) || 0,
      loading: false,
      autoFilling: false,
      clicked: false,
    };

    var s = state;
    var shown = grid.querySelectorAll('.product--item').length;
    if (shown < s.batch && s.nextUrl) {
      s.autoFilling = true;
      fill(s.batch - shown).then(function () {
        s.autoFilling = false;
        render();
      });
    } else {
      render();
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-fs-load-more-link]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    event.preventDefault();
    if (!state || state.link !== link) init();
    if (!state || state.loading) return;
    state.clicked = true;
    fill(state.batch).then(function (added) {
      if (!added.length) return;
      var firstLink = added[0].querySelector('a[href]');
      if (firstLink) firstLink.focus({ preventScroll: true });
    });
  });

  function watchGrid() {
    var root = document.getElementById('ProductGridContainer');
    if (!root || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      init();
    }).observe(root, { childList: true });
  }

  function start() {
    init();
    watchGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
